var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"18","viewBox":"0 0 24 30","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M18 2H0v28h24V8l-6-6zm4 26H2V4h14l6 6v18zM12 14c-4.656 0-8 3.469-8 10 1-4.25 4.094-6 8-6v4l8-6-8-6v4z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }